import { OnTrackRegentsTransferCtrl } from './on-track-regents-transfer.controller';

export const OnTrackRegentsStepTransferComponent = {
  controller: OnTrackRegentsTransferCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./on-track-regents-transfer.html'),
};
